<template>
  <span @click.prevent="$emit('input-click')">
    <vue-typer
      v-if="vueTyperConfig && vueTyperConfig.text"
      v-bind="vueTyperConfig"
    />
  </span>
</template>

<script>
import { VueTyper } from 'vue-typer';
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseVueTyper',

  components: {
    VueTyper,
  },

  mixins: [bemClassesMixin],

  props: {
    text: {
      type: String,
      default: null,
    },
    repeat: {
      type: String,
      default: 'Infinity',
    },
    shuffle: {
      type: Boolean,
      default: false,
    },
    initialAction: {
      type: String,
      default: 'typing',
    },
    preTypeDelay: {
      type: Number,
      default: 250,
    },
    typeDelay: {
      type: Number,
      default: 25,
    },
    preEraseDelay: {
      type: Number,
      default: 2000,
    },
    eraseDelay: {
      type: Number,
      default: 25,
    },
    eraseStyle: {
      type: String,
      default: 'backspace',
    },
    eraseOnComplete: {
      type: Boolean,
      default: true,
    },
    caretAnimation: {
      type: String,
      default: 'blink',
    },
  },

  data() {
    return {
      vueTyperConfig: {},
    };
  },

  created() {
    this.vueTyperConfig = this.buildVueTyperConfig();
  },

  methods: {
    buildVueTyperConfig() {
      let text = null;
      if (
        this.text &&
        typeof this.text === 'string' &&
        this.text.trim().length > 0
      ) {
        text = this.text.split('\n').filter((line) => line.trim().length > 0);
      }
      let repeat = Infinity;
      if (
        this.repeat !== undefined &&
        this.repeat !== 'Infinity' &&
        this.repeat !== Infinity
      ) {
        const num = Number(this.repeat);
        repeat = Number.isNaN(num) || num < 0 ? Infinity : Math.floor(num);
      }
      return {
        text,
        repeat,
        shuffle: this.shuffle,
        initialAction: this.initialAction,
        preTypeDelay: this.preTypeDelay,
        typeDelay: this.typeDelay,
        preEraseDelay: this.preEraseDelay,
        eraseDelay: this.eraseDelay,
        eraseStyle: this.eraseStyle,
        eraseOnComplete: this.eraseOnComplete,
        caretAnimation: this.caretAnimation,
      };
    },
  },
};
</script>
